import { timeParse } from "d3";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Exposure data, with Fwd Valuation
 * @param {object} _this: context variables
 * @param {string} fieldName: field name to update
 * @param {string} fieldShowLoadingName: field name that defines if the field must be shown loading
 */
export function getFutureExposureData(_this, fieldName, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "GET",
    endpoint: "currency_future_exposure",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency: _this.currencyNumber,
      portfolios: { id_portfolios: _this.portfolioNumbers },
      date: formatDate_YMD(new Date())
    }
  };
  apiService
    .getAll(params)
    .then(data => {
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.pk = d.pk_idcurrencyexposure;
        d.date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.planned_expiration_date);
        d.hedged_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.hedged_date);
        d.sale_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.sale_date);
      });
      // console.log(data.map(d => d.date))
      _this[fieldName] = data;
      _this[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
